export default ({ app }) => {
    if (process.client) {
      const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = ''; // Some browsers require this for the prompt to show up
      };
  
      window.addEventListener('beforeunload', handleBeforeUnload);
  
      app.router.beforeEach((to, from, next) => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        next();
      });
    }
  };